<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent scrollable width="auto" :fullscreen="$vuetify.breakpoint.mobile">
      <v-form ref="formRecibo" v-model="valid" lazy-validation @submit.prevent="saveData">
        <v-card tile style="min-width:700px; max-width:950px">
          <v-toolbar flat dark color="teal darken-3">
            <v-icon class="mr-2">mdi-receipt-text-plus</v-icon>
            <v-toolbar-title>Registrar Cobro Suelto</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>

          <v-card-text class="pa-4">
            <!-- Buscar por carnet -->
            <v-row no-gutters align="center">
              <v-col cols="8">
                <v-text-field
                  v-model="searchCarnet"
                  :loading="searchingpersona"
                  prepend-inner-icon="mdi-card-account-details"
                  outlined dense autofocus
                  label="Buscar por número de carnet (C.I.)"
                  hide-details
                  @keyup.enter="buscarPorCarnet"
                  clearable
                  @click:clear="resetBusqueda">
                </v-text-field>
              </v-col>
              <v-col cols="auto" class="pl-2">
                <v-btn color="teal darken-2" dark @click="buscarPorCarnet" :loading="searchingpersona">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="auto" class="pl-2"
                v-if="puedeRegistrar && $store.state.CARGO && ($store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 15 || $store.state.CARGO.id == 25)">
                <v-btn color="purple" small dark @click="openregistrarCaja()">
                  <v-icon small left>mdi-package-variant</v-icon> Caja
                </v-btn>
              </v-col>
            </v-row>

            <!-- Alertas de estado de búsqueda -->
            <v-alert
              v-if="personaInscritaEnSede"
              type="error" dense border="left" colored-border elevation="1" class="mt-3 mb-0">
              <strong>{{ personaEncontrada.nombres }}</strong> está inscrito/a en uno o más programas activos de esta sede.
              Use <strong>"Registrar Cobro"</strong> para generar el recibo.
            </v-alert>

            <v-alert
              v-else-if="personaEncontrada && personaBuscada"
              type="success" dense border="left" colored-border elevation="1" class="mt-3 mb-0">
              Persona encontrada: <strong>{{ personaEncontrada.nombres }}</strong> (C.I.: {{ personaEncontrada.num_doc }}).
              No tiene inscripciones activas en esta sede. Se puede continuar.
            </v-alert>

            <v-alert
              v-else-if="!personaEncontrada && personaBuscada"
              type="info" dense border="left" colored-border elevation="1" class="mt-3 mb-0">
              Carnet <strong>{{ searchCarnet }}</strong> no encontrado en el sistema. Se puede continuar ingresando los datos del depositante.
            </v-alert>

            <!-- Formulario de pago -->
            <div v-if="puedeRegistrar">
              <v-divider class="mt-3 mb-3"></v-divider>

              <v-card outlined class="mb-3">
                <v-card-title class="py-2 px-3 blue lighten-5 subtitle-2 blue--text text--darken-3">
                  <v-icon small left color="blue darken-3">mdi-cash-register</v-icon>
                  Datos del Pago
                </v-card-title>
                <v-card-text class="pt-5 pb-1">
                  <v-row>
                    <v-col cols="12" sm="4" class="py-0">
                      <v-select
                        v-model="forma"
                        :items="formas_pago"
                        :rules="fieldRules"
                        :loading="loadingformas"
                        item-text="nombre"
                        outlined dense
                        label="Forma de Pago"
                        return-object>
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="4" class="py-0">
                      <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :rules="fieldRules"
                            readonly
                            label="Fecha de Pago"
                            v-model="fecha_pago"
                            outlined dense
                            prepend-inner-icon="mdi-calendar"
                            v-bind="attrs" v-on="on">
                          </v-text-field>
                        </template>
                        <v-date-picker v-model="date" locale="es-ES" @input="menu1 = false" :max="maxDate()"></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="4" class="py-0"></v-col>
                    <v-col cols="12" sm="4" class="py-0">
                      <v-text-field
                        v-model.trim="nombre_depositante"
                        outlined dense
                        :rules="fieldRules"
                        prepend-inner-icon="mdi-account-edit"
                        label="Nombre del Depositante">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" class="py-0">
                      <v-text-field
                        v-model.trim="num_doc_depositante"
                        outlined dense
                        prepend-inner-icon="mdi-card-account-details"
                        label="C.I. del Depositante">
                      </v-text-field>
                    </v-col>
                    <template v-if="forma && forma.id == 2">
                      <v-col cols="12" sm="4" class="py-0">
                        <v-select
                          v-model="cuenta"
                          :items="cuentas_bancarias"
                          item-text="nombre"
                          outlined dense
                          :rules="fieldRules"
                          prepend-inner-icon="mdi-bank"
                          label="N° de Cuenta Bancaria"
                          return-object>
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="8" class="py-0">
                        <v-text-field
                          v-model="numero_deposito"
                          :rules="fieldRules"
                          outlined dense
                          prepend-inner-icon="mdi-identifier"
                          label="N° Comprobante / Bancarización / Depósito"
                          hint="Número de comprobante/Bancarización/depósito de la transferencia">
                        </v-text-field>
                      </v-col>
                    </template>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Pagos opcionales e items -->
              <v-row>
                <v-col cols="12" sm="6" class="py-0">
                  <v-text-field
                    v-model="searchOpcionales"
                    prepend-inner-icon="mdi-magnify"
                    placeholder="Buscar pago opcional..."
                    dense outlined hide-details clearable class="mb-1" />
                  <v-data-table
                    :headers="headersOptional"
                    :items="pagos_opcionales"
                    :search="searchOpcionales"
                    :loading="loadingOpcionales"
                    item-key="index"
                    class="elevation-2"
                    dense>
                    <template v-slot:top>
                      <div class="py-2 px-3 orange lighten-5">
                        <span class="subtitle-2 orange--text text--darken-3">
                          <v-icon small left color="orange darken-3">mdi-star-circle-outline</v-icon>
                          Pagos Opcionales
                        </span>
                      </div>
                    </template>
                    <template v-slot:[`item.options`]="{ item }">
                      <v-icon class="ma-2" color="orange" @click="addItem(item)">mdi-plus-circle</v-icon>
                    </template>
                  </v-data-table>
                </v-col>

                <v-col v-if="items.length" cols="12" sm="6" class="py-0">
                  <v-data-table
                    :headers="headersItems"
                    :items="items"
                    class="elevation-2"
                    hide-default-footer
                    disable-pagination
                    dense>
                    <template v-slot:top>
                      <div class="py-2 px-3 green lighten-5">
                        <span class="subtitle-2 green--text text--darken-3">
                          <v-icon small left color="green darken-3">mdi-receipt-text</v-icon>
                          Items del Recibo
                        </span>
                      </div>
                    </template>
                    <template v-slot:[`item.cantidad`]="{ item }">
                      <v-text-field
                        type="number"
                        v-model.number="item.cantidad"
                        @input="updatesubtotal(item)"
                        outlined dense :max="100" style="width:70px">
                      </v-text-field>
                    </template>
                    <template v-slot:[`item.monto`]="{ item }">
                      <v-text-field
                        type="number"
                        v-model.number="item.monto"
                        outlined dense
                        @input="updatesubtotal(item)"
                        @change="updateTotal"
                        :rules="[rules.required, rules.loanMin]"
                        style="width:100px">
                      </v-text-field>
                    </template>
                    <template v-slot:[`item.subtotal`]="{ item }">
                      <p class="font-weight-bold green--text text--darken-2 mb-0">{{ item.subtotal }}</p>
                    </template>
                    <template v-slot:[`item.options`]="{ item }">
                      <v-btn icon small @click="removeItem(item)" color="red darken-1">
                        <v-icon small>mdi-delete-alert</v-icon>
                      </v-btn>
                    </template>
                    <template v-slot:footer>
                      <v-divider></v-divider>
                      <v-row justify="end" class="mx-2 my-1">
                        <v-col md="5" sm="6">
                          <v-text-field
                            v-model="total"
                            outlined dense readonly
                            :label="`TOTAL (${montostr})`"
                            background-color="green lighten-5">
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </div>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn
              type="submit"
              :loading="enviando"
              color="success"
              v-if="puedeRegistrar && items.length"
              rounded small>
              <v-icon small class="mr-1">mdi-check-circle</v-icon> Guardar
            </v-btn>
            <v-btn color="grey darken-1" outlined rounded small @click="closeDialog">
              <v-icon small left>mdi-close</v-icon> Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <comprobar ref="refcomprobar" v-on:success="()=>{}"/>
  </v-row>
</template>

<script>
import gql from 'graphql-tag';
import xaxios from '@/xaxios';
import comprobar from '@/views/nominaciones/cajas/comprobar.vue';

export default {
  components: { comprobar },
  data() {
    return {
      api_rest: process.env.VUE_APP_API_REST,
      dialog: false,
      valid: false,
      enviando: false,
      searchingpersona: false,
      loadingOpcionales: false,
      loadingformas: false,
      searchCarnet: '',
      personaEncontrada: null,
      personaBuscada: false,
      personaInscritaEnSede: false,
      fecha_pago: null,
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      nombre_depositante: null,
      num_doc_depositante: null,
      forma: null,
      formas_pago: [],
      cuenta: null,
      cuentas_bancarias: [],
      numero_deposito: null,
      searchOpcionales: '',
      pagos_opcionales: [],
      items: [],
      total: 0,
      fieldRules: [(v) => !!v || 'Campo Obligatorio'],
      rules: {
        required: (value) => !!value || 'Se requiere un monto',
        loanMin: (value) => value > 0 || 'Monto debe ser mayor a 0',
      },
      headersOptional: [
        { text: 'Concepto', value: 'concepto' },
        { text: 'Monto', value: 'monto' },
        { text: 'Añadir', value: 'options', sortable: false, width: 80 },
      ],
      headersItems: [
        { text: 'Concepto', value: 'concepto' },
        { text: 'Cantidad', value: 'cantidad', width: 100 },
        { text: 'Monto', value: 'monto', width: 120 },
        { text: 'Subtotal', value: 'subtotal' },
        { text: 'Remover', value: 'options', sortable: false, width: 80 },
      ],
    };
  },
  computed: {
    puedeRegistrar() {
      return this.personaBuscada && !this.personaInscritaEnSede;
    },
    montostr() {
      const un = this.$store.state.CARGO.sede.unidad_negocio;
      if (un == 15) return '$';
      return 'Bs.';
    },
  },
  watch: {
    date() {
      this.fecha_pago = this.formatDate(this.date);
    },
    forma() {
      this.getCuentasBancarias(this.$store.state.CARGO.sede.id);
    },
    dialog(val) {
      val || this.closeDialog();
    },
    puedeRegistrar(val) {
      if (val) this.loadConceptosOptionals();
    },
  },
  methods: {
    openmodal() {
      this.dialog = true;
    },

    async buscarPorCarnet() {
      if (!this.searchCarnet || this.searchCarnet.trim().length < 2) {
        this.$root.$notify.show('Ingrese al menos 2 caracteres del carnet', { color: 'orange' });
        return;
      }
      this.searchingpersona = true;
      this.personaBuscada = false;
      this.personaEncontrada = null;
      this.personaInscritaEnSede = false;
      this.items = [];
      this.pagos_opcionales = [];

      try {
        const query = gql`query { getPersonasByDoc(num_doc: "${this.searchCarnet.trim()}", estado: true) { id num_doc nombres pri_apellido seg_apellido } }`;
        const { data } = await this.$apollo.query({ query });
        const personas = data.getPersonasByDoc;

        if (personas && personas.length > 0) {
          const p = personas[0];
          p.nombres = `${p.nombres} ${p.pri_apellido} ${p.seg_apellido ? p.seg_apellido : ''}`.trim();
          this.personaEncontrada = p;
          await this.checkInscripcionesBySede(p.id);
        } else {
          this.personaBuscada = true;
        }
      } catch (e) {
        window.console.error(e);
        this.$root.$notify.show('Error al buscar la persona', { color: 'red' });
        this.personaBuscada = true;
      } finally {
        this.searchingpersona = false;
      }
    },

    async checkInscripcionesBySede(student_id) {
      try {
        const url = `${this.api_rest}/api/esam/inscripcion/estudiante/id/${student_id}`;
        const { data } = await xaxios.get(url);
        const inscritos = (data || []).filter(x =>
          x.estado_inscripcion == 1 &&
          x.programa &&
          x.programa.sede_id == this.$store.state.CARGO.sede.id
        );
        this.personaInscritaEnSede = inscritos.length > 0;
        this.personaBuscada = true;
        if (!this.personaInscritaEnSede && this.personaEncontrada) {
          this.nombre_depositante = this.personaEncontrada.nombres;
          this.num_doc_depositante = this.personaEncontrada.num_doc;
        }
      } catch (e) {
        window.console.error(e);
        this.personaBuscada = true;
      }
    },

    resetBusqueda() {
      this.personaBuscada = false;
      this.personaEncontrada = null;
      this.personaInscritaEnSede = false;
      this.items = [];
      this.pagos_opcionales = [];
      this.nombre_depositante = null;
      this.num_doc_depositante = null;
    },

    loadConceptosOptionals() {
      this.loadingOpcionales = true;
      const url = `${this.api_rest}/api/pagos/conceptos/buscar`;
      const datasend = { unidad_negocio_id: this.$store.state.UNIDAD_NEGOCIO_ID, es_nacional: false };
      xaxios.post(url, datasend)
        .then(({ data }) => {
          data = data.filter(c => c.opcional && c.estado);
          this.pagos_opcionales = data.map((c, i = 0) => ({
            ...c,
            index: ++i,
            concepto_id: c.id,
            concepto: c.nombre,
            saldo: c.monto,
            numero_cuota: 1,
            optional: true,
            editable: true,
            cantidad: 1,
            subtotal: 0,
          }));
          this.loadingOpcionales = false;
        })
        .catch(() => {
          this.$root.$notify.show('No se logró cargar los pagos opcionales', { color: 'primary' });
          this.loadingOpcionales = false;
        });
    },

    addItem(item) {
      item.cantidad = 1;
      item.subtotal = Math.round(Number(item.monto * 1) * 100) / 100;
      this.items.push(item);
      const index = this.pagos_opcionales.indexOf(item);
      this.pagos_opcionales.splice(index, 1);
      this.updateTotal();
    },

    removeItem(item) {
      const index = this.items.indexOf(item);
      this.items.splice(index, 1);
      item.monto = item.saldo;
      item.subtotal = 0;
      item.cantidad = 1;
      this.pagos_opcionales.push(item);
      this.pagos_opcionales.sort((a, b) => a.index - b.index);
      this.updateTotal();
    },

    updateTotal() {
      let xtotal = 0;
      this.items.forEach(item => (xtotal += item.subtotal));
      this.total = Math.round(Number(xtotal) * 100) / 100;
    },

    updatesubtotal(item) {
      item.subtotal = Math.round(Number(item.cantidad * item.monto) * 100) / 100;
      this.updateTotal();
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },

    maxDate() {
      return new Date().toISOString().substr(0, 10);
    },

    async getFormasdePago() {
      if (this.formas_pago.length > 0) return;
      this.loadingformas = true;
      try {
        const { data: res } = await xaxios.get(`${this.api_rest}/api/v1/esam/formaspagos`);
        this.formas_pago = res.data;
      } catch (e) {
        window.console.error(e);
      } finally {
        this.loadingformas = false;
      }
    },

    getCuentasBancarias(sede_id) {
      this.numero_deposito = null;
      this.cuenta = null;
      const sql = gql`query{getSede(id: ${sede_id}) { id, nombre, cuentasBancarias{ id, nombre, descripcion, nro, estado } ${''}}}`;
      this.$apollo.query({ query: sql }).then(({ data }) => {
        let cuentas = (data.getSede.cuentasBancarias || []).map(c => ({
          ...c,
          nombre: `${c.nombre}  -  ${c.nro}`,
        }));
        this.cuentas_bancarias = cuentas.filter(c => c.estado);
      });
    },

    openregistrarCaja() {
      this.$refs.refcomprobar.openmodal(null);
    },

    async saveData() {
      if (!this.$refs.formRecibo.validate()) {
        this.$root.$notify.show('Faltan completar algunos campos', { color: 'red', x: 'right' });
        return;
      }
      const confirmed = await this.$root.$confirm.open(
        'Generar Recibo Suelto',
        '¿Estás seguro de guardar el recibo?',
        { color: 'orange' }
      );
      if (!confirmed) return;

      const formData = {
        unidad_negocio_id: this.$store.state.UNIDAD_NEGOCIO_ID,
        inscripcion_id: null,
        nombre_depositante: this.nombre_depositante ? this.nombre_depositante.trim() : null,
        numero_documento_depositante: this.num_doc_depositante ? this.num_doc_depositante.trim() : null,
        forma_pago_id: this.forma.id,
        cuenta_bancaria_id: this.cuenta ? this.cuenta.id : null,
        numero_cuenta: this.cuenta ? this.cuenta.nro : null,
        emisor_id: this.$store.state.DATA_USER.id,
        sede_id: this.$store.state.CARGO.idsede,
        numero_comprobante: this.numero_deposito ? this.numero_deposito.trim() : null,
        fondo_recibo: this.$store.state.CARGO.sede.modelo_recibo,
        fecha_pago: this.fecha_pago,
        tipo_pago: false,
        lugar: this.$store.state.CARGO.sede.nombre,
        persona_id: this.personaEncontrada ? this.personaEncontrada.id : null,
        cuotas: this.items.map(item => ({
          cuota_id: null,
          concepto: item.concepto,
          monto: +item.monto,
          concepto_id: item.concepto_id,
          opcional: true,
          cantidad: item.cantidad,
          precio_unitario: +item.monto,
        })),
      };

      const url = `${this.api_rest}/api/pagos/inscripcion`;
      this.enviando = true;
      xaxios.post(url, formData)
        .then((res) => {
          this.enviando = false;
          const recibo_id = res.data.recibo_id;
          this.$root.$notify.show('Recibo generado exitosamente', { color: 'success' });
          this.$emit('reloadRecibos', true, recibo_id);
          this.closeDialog();
        })
        .catch((error) => {
          this.enviando = false;
          this.$root.$notify.show(
            `${error.response ? error.response.data.error : 'Error en la Transaccion'}`,
            { color: 'red', timeout: 5000 }
          );
        });
    },

    closeDialog() {
      this.dialog = false;
      this.$nextTick(() => {
        this.searchCarnet = '';
        this.personaEncontrada = null;
        this.personaBuscada = false;
        this.personaInscritaEnSede = false;
        this.items = [];
        this.pagos_opcionales = [];
        this.nombre_depositante = null;
        this.num_doc_depositante = null;
        this.forma = null;
        this.cuenta = null;
        this.numero_deposito = null;
        this.total = 0;
        this.enviando = false;
        this.searchOpcionales = '';
      });
    },
  },
  mounted() {
    this.fecha_pago = this.formatDate(this.date);
    this.getFormasdePago();
  },
};
</script>
